module.exports = __webpack_public_path__ + "static/media/icon-logo.5ad6a9c8.svg";